<template>
    <transition name="fade"> 
        <div class="order-exchange-return">
            <div class="exchange-return-body">
                <Icon type="md-close" @click="close" size="18" class="close-ico" />
                <div class="main-title">驳回申请</div>
                <div class="after-sale-info">
                    <div class="title">售后详情</div>
                    <div class="detail">
                        <div class="detail-item">
                            <div class="label">订单编号：</div>
                            <div class="value">{{order.ord.order_no}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">售后类型：</div>
                            <div class="value main">{{order.type_name}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">退货原因：</div>
                            <div class="value">{{order.user_reason}}</div>
                        </div>
                        <div class="img-list" v-viewer>
                            <img v-for="(item,index) in order.user_proof" :key="index" :src="item|default_img" alt="" class="img-item" />
                        </div>
                        <div class="detail-item">
                            <div class="label">退款金额：</div>
                            <div class="value main">¥{{order.apply_money}}</div>
                        </div>
                        <div class="refund-money-box">
                            <div class="refund-item">
                                <div class="label">退货商品金额:</div>
                                <div class="value">¥{{order.goods.price}}</div>
                            </div>
                            <div class="refund-item" v-if="false">
                                <div class="label">发货运费:</div>
                                <div class="value">-¥88.88</div>
                            </div>
                        </div>
                        <div class="refund-tips">
                            退货后订单剩余金额不满足运费条件,客户需承担5元发货运费,从本次退款金额中扣除
                        </div>
                    </div>
                    <div class="title required">驳回原因</div>
                    <div class="refund-reject-reason">
                        <Select placeholder="请选择驳回原因" v-model="form.shop_reason">
                            <Option value="超出7天售后期限">超出7天售后期限</Option>
                            <Option value="商品不符合售后标准(吊牌缺失/已使用)">商品不符合售后标准(吊牌缺失/已使用)</Option>
                            <Option value="换货商品无库存(仅换货)">换货商品无库存(仅换货)</Option>
                            <Option value="其它原因">其它原因</Option>
                        </Select>
                    </div>
                    <div class="title">驳回备注(可选)</div>
                    <textarea v-model="form.shop_memo" placeholder="请详细填写驳回原因,方便买家理解"></textarea>
                    <div class="tips">选择驳回原因并填写备注,确认驳回后买家将收到驳回通知</div>
                    <div class="btn-box">
                        <div class="btn cancel" @click="close">取消</div>
                        <div class="btn confirm" @click="onRejectConfirm">确认驳回</div>
                    </div>
                </div>
            </div>
            
        </div>
    </transition>
</template>
<script>
import { afterSaleApplyReject } from '@/api/index';
export default{
    name:"OrderExchangeOrReturnReject",
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            form:{
                uuid:'',
                shop_reason:'',
                shop_proof:[],
                shop_memo:''
            }
        }
    },
    mounted(){
        this.form.uuid = this.order.uuid;
    },
    methods:{
        async onRejectConfirm(){
            try{
                const {code,msg} = await afterSaleApplyReject(this.form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$bus.$emit('list-refresh');
                this.close();
            }catch(e){
                console.log('err-after-sale-apply-reject',e);
            }
        },
        close(){
            this.$emit("close")
        }
    }
}
</script>
<style lang="scss" scoped>
.order-exchange-return{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.5);
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:110;
    user-select: none;
    .exchange-return-body{
        width:508px;
        height:auto;
        max-height:800px;
        overflow-y:auto;
        position:relative;
        background:#fff;
        border-radius:10px;
        .close-ico{
            position:absolute;
            top:14px;
            right:14px;
            cursor:pointer;
        }
        .main-title{
            width:100%;
            text-align:center;
            margin-top:18px;
            padding-bottom:13px;
            font-size:18px;
            font-weight:bold;
            color:#0f1115;
            border-bottom:1px solid #e0e0e0;
        }
        .after-sale-info{
            width:100%;
            padding:0 24px;
            .title{
                color:#333;
                font-size:14px;
                margin-top:13px;
                &.required::after{
                    content:"*";
                    color:red;
                }
            }
            .detail{
                width:100%;
                background:#f6f7f9;
                padding:14px 14px 8px 14px;
                border-radius:6px;
                display:flex;
                flex-direction:column;
                row-gap:9px;
                margin-top:8px;
                .detail-item{
                    width:100%;
                    display:flex;
                    align-items:center;
                    .label{
                        color:#333;
                        font-size:14px;
                    }
                    .value{
                        color:#333;
                        font-size:14px;
                        &.main{
                            color:#ff5967;
                            font-weight:bold;
                        }
                    }
                    .edit-btn{
                        display:flex;
                        align-items:center;
                        padding:0 8px;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        column-gap:4px;
                        cursor:pointer;
                        margin-left:16px;
                        .btn-icon{
                            width:16px;
                            height:16px;
                        }
                        .btn-text{
                            color:#666;
                            font-size:12px;
                        }
                    }
                }
                .img-list{
                    display:flex;
                    flex-wrap:wrap;
                    gap:8px;
                    .img-item{
                        width:60px;
                        height:60px;
                    }
                }
                .refund-money-box{
                    width:100%;
                    border-radius:6px;
                    background:#fff;
                    padding:9px 10px;
                    display:flex;
                    flex-direction:column;
                    row-gap:6px;
                    .refund-item{
                        display:flex;
                        align-items:center;
                        justify-content:space-between;
                        .label{
                            color:#333;
                            font-size:12px;
                        }
                        .value{
                            color:#333;
                            font-size:12px;
                        }
                    }
                }
                .refund-tips{
                    color:#ff5000;
                    font-size:12px;
                }
            }
            .refund-reject-reason{
                width:100%;
                margin-top:10px;
            }
            textarea{
                width:100%;
                height:100px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                outline:none;
                padding:12px 16px;
                resize:none;
                margin-top:10px;
            }
            .tips{
                color:#666;
                font-size:12px;
                margin-top:10px;
            }
            .btn-box{
                width:100%;
                display:flex;
                justify-content:center;
                align-items:center;
                column-gap:10px;
                margin-top:27px;
                margin-bottom:27px;
                .btn{
                    font-size:14px;
                    cursor:pointer;
                    font-weight:bold;
                    height:40px;
                    line-height:40px;
                    border-radius:4px;
                    &.cancel{
                        color:#666;
                        border:1px solid #e3e3e3;
                        padding:0 36px;
                    }
                    &.confirm{
                        color:#fff;
                        background:#ff5967;
                        padding:0 34px;
                    }
                }
            }
        }
    }
}
::v-deep .change-money-body{
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    .label{
        color:#333;
        font-size:14px;
        margin-bottom:10px;
        width:100%;
        text-align:left;
    }
    .value{
        width:100%;
        height:48px;
        border:1px solid #e3e3e3;
        border-radius:4px;
        outline:none;
        padding:0 16px;
    }
}

::v-deep .footer-box{
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top:20px;
    margin-bottom:40px;
    column-gap:10px;
    .btn{
        font-size:14px;
        cursor:pointer;
        font-weight:bold;
        height:40px;
        line-height:40px;
        border-radius:4px;
        &.cancel{
            color:#666;
            border:1px solid #e3e3e3;
            padding:0 36px;
        }
        &.confirm{
            color:#fff;
            background:#ff5967;
            padding:0 34px;
        }
    }
}

::v-deep .ivu-modal-header{
    border-bottom:none;
}
::v-deep .ivu-modal-footer{
    border-top:none;
}
::v-deep .ivu-modal{
    top:30% !important;
}
</style>